/**
 * ANOTHR Ingredients Page — Interactivity
 * - Fade-up on scroll (IntersectionObserver)
 * - Carousel arrow navigation + state
 * - Video pause when out of viewport
 */

(function () {
  'use strict';

  function init() {
    // --- Fade-up animations ---
    const fadeEls = document.querySelectorAll('.ing-fade-up');

    if (fadeEls.length && 'IntersectionObserver' in window) {
      const fadeObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              fadeObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );

      fadeEls.forEach((el) => fadeObserver.observe(el));
    }

    // --- Carousel ---
    const track = document.querySelector('[data-ing-carousel="track"]');
    const prevBtn = document.querySelector('[data-ing-carousel="prev"]');
    const nextBtn = document.querySelector('[data-ing-carousel="next"]');

    if (track && prevBtn && nextBtn) {
      const getCardWidth = () => {
        const firstCard = track.querySelector('.ing-card');
        if (!firstCard) return 320;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap || '24');
        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateArrowState = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', () => {
        requestAnimationFrame(updateArrowState);
      });

      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    }

    // --- Video: pause when out of viewport (save CPU) ---
    const heroVideo = document.querySelector('.ing-hero__media video');
    if (heroVideo && 'IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              heroVideo.play().catch(() => {});
            } else {
              heroVideo.pause();
            }
          });
        },
        { threshold: 0.1 }
      );
      videoObserver.observe(heroVideo);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
